import "./App.css";
import { TextInput, DateOfBirthInput, PhoneInput } from "./components/InputModal";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import "./otpScreen.scss";
import LoadingScreen from "./components/LoadingScreen";

const PrizeItem = ({ place, imgSrc, name }) => {
  return (
    <div className="prizeItemContainer">
      <p className="place">{place} place</p>
      <div className="imageBlock">
        <img src={imgSrc} alt="Loading..." />
      </div>
      <p className="prizeName">{name}</p>
    </div>
  );
};

const OTPInput = ({ otp, setOtp }) => {
  const otp1Ref = useRef(null);
  const otp2Ref = useRef(null);
  const otp3Ref = useRef(null);
  const otp4Ref = useRef(null);

  const handleChange = (e, index) => {
    const { value } = e.target;
    // Allow only digits
    const digitValue = value.replace(/[^\d]/g, "");

    const newOtp = { ...otp, [`otp${index}`]: digitValue };
    setOtp(newOtp);

    // Focus next input field if a digit is entered
    if (digitValue && index < 4) {
      const nextInputRef = `otp${index + 1}Ref`;
      if (eval(nextInputRef).current) {
        eval(nextInputRef).current.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[`otp${index}`] && index > 1) {
      const prevInputRef = `otp${index - 1}Ref`;
      if (eval(prevInputRef).current) {
        eval(prevInputRef).current.focus();
      }
    }
  };

  return (
    <div className="OTPInput">
      {[1, 2, 3, 4].map((index) => (
        <input
          key={index}
          ref={eval(`otp${index}Ref`)}
          type="text"
          maxLength="1"
          value={otp[`otp${index}`]}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          autoComplete="one-time-code"
          style={{ width: "50px", marginRight: "10px" }}
        />
      ))}
    </div>
  );
};

function App() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [errorsObject, setErrorsObject] = useState({
    name: false,
    dob: false,
    email: false,
    phone: false,
    checkbox: false,
  });
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dialCode, setDialCode] = useState("+91");
  const [errorText, setErrorText] = useState("");
  const [checkboxDone, setCheckboxDone] = useState(true);
  const [showOTPScreen, setShowOTPScreen] = useState(false);
  const [DOB, setDOB] = useState("");
  const [OTPErrorText, setOTPErrorText] = useState("");
  const [otp, setOtp] = useState({ otp1: "", otp2: "", otp3: "", otp4: "" });
  const [showSendAgain, setShowSendAgain] = useState(false);
  const [showCompletedWindow, setShowCompletedWindow] = useState(false);
  const [showLoading, setShowLoading] = useState(true);

  const scrollToFeatures = () => {
    const featuresElement = document.getElementById("participationBlock");
    if (featuresElement) {
      featuresElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const sendAgain = () => {
    setShowSendAgain(false);
    sendOTP();

    setTimeout(() => {
      setShowSendAgain(true);
    }, 60000);
  };

  useEffect(() => {
    setTimeout(() => {
      setShowLoading(false);
    }, 1500);
  }, []);

  useEffect(() => {
    if (showOTPScreen === true) {
      setShowSendAgain(false);

      setTimeout(() => {
        setShowSendAgain(true);
      }, 60000);
    }
  }, [showOTPScreen]);

  const checkOTP = async () => {
    const cleanOTP = `${otp?.otp1}${otp?.otp2}${otp?.otp3}${otp?.otp4}`;

    axios
      .post("https://batery.ai:3000/checkOTP", {
        phoneNumber: `${dialCode}${phoneNumber}`,
        OTP: cleanOTP,
        DOB,
        email,
        requestSource: "Batery JPP Landing",
      })
      .then((data) => {
        if (data?.data?.status === 200) {
          setOTPErrorText("");
          setShowCompletedWindow(true);
        } else {
          setOTPErrorText(`OTP is incorrect`);
        }
      });
  };

  const sendOTP = async () => {
    if (dialCode?.length > 0 && phoneNumber?.length > 3) {
      setErrorText("");
      const response = await axios.post("https://batery.ai:3000/sendCode", {
        phoneNumber: `${dialCode}${phoneNumber}`,
        requestSource: "Batery JPP Landing",
      });

      if (response?.data?.status !== 200) {
        setErrorText("Can't send OTP, check the phone number or try again later please");
      } else {
        setShowOTPScreen(true);
      }
    } else {
      if (!dialCode?.length || dialCode?.length <= 0) {
        setErrorText("Select country");
      } else if (!checkboxDone) {
        setErrorText("Accept privacy policy to proceed");
      } else {
        setErrorText("Phone number is incorrect");
      }
    }
  };

  const validateData = async () => {
    let foundError = false;

    if (name?.length < 1) {
      foundError = true;
      setErrorsObject((prevObject) => ({
        ...prevObject,
        name: true,
      }));

      setErrorText(`Please, write your name`);
    } else {
      setErrorsObject((prevObject) => ({
        ...prevObject,
        name: false,
      }));
    }

    if (!checkboxDone) {
      foundError = true;
      setErrorsObject((prevObject) => ({
        ...prevObject,
        checkbox: true,
      }));

      setErrorText(`Accept policy to proceed`);
    } else {
      setErrorsObject((prevObject) => ({
        ...prevObject,
        checkbox: false,
      }));
    }

    if (email?.length < 4 || !email.includes("@") || !email.includes(".")) {
      foundError = true;
      setErrorsObject((prevObject) => ({
        ...prevObject,
        email: true,
      }));

      setErrorText(`Enter valid email`);
    } else {
      setErrorsObject((prevObject) => ({
        ...prevObject,
        email: false,
      }));
    }

    if (DOB?.length < 1) {
      foundError = true;
      setErrorsObject((prevObject) => ({
        ...prevObject,
        dob: true,
      }));

      setErrorText(`Enter your date of birth`);
    } else {
      setErrorsObject((prevObject) => ({
        ...prevObject,
        dob: false,
      }));
    }

    if (foundError === false) {
      sendOTP();
    }
  };

  return (
    <div className="wrapper">
      {showLoading && <LoadingScreen />}

      <div className="headerWrapper">
        <div className="logo">
          <img src="/bateryLogo.png" alt="Loading..." />
        </div>
        <p>X</p>
        <div className="logo">
          <img src="/pinkLogo.png" alt="Loading..." />
        </div>
      </div>

      <div className="overviewWrapper">
        <div className="overviewTitleContainer">
          <p className="mainTitle">Pink Panthers Big Games</p>
          <p className="underTitle">January 12-17</p>
        </div>

        <div className="sidesContainer">
          <div className="imgContainer">
            <img src="/guys.png" alt="Loading..." />
          </div>

          <div className="buttonContainer">
            <p>Support your team and win big prizes!</p>
            <div className="buttonBlock">
              <button onClick={scrollToFeatures}>Join now</button>
            </div>
          </div>
        </div>
      </div>

      <div className="prizesWrapper">
        <div className="prizesContainer">
          <PrizeItem place="1st" imgSrc={"/player.png"} name={"VIP tickets for home games"} />
          <PrizeItem place="2nd" imgSrc={"/samsung.png"} name={"Samsung Galaxy z flip 5"} />
          <PrizeItem place="3rd" imgSrc={"/headphones.png"} name={"AIRPODS PRO"} />
          <PrizeItem place="4th" imgSrc={"/shirt.png"} name={"JAIPUR PINK PANTHERS AUTOGRAPHED JERSEY"} />
        </div>

        <div className="buttonsBlock">
          <button onClick={scrollToFeatures}>Take Part</button>
        </div>
      </div>

      <div className="participationWrapper" id="participationBlock">
        {showCompletedWindow === true ? (
          <div className="participationContainer">
            <p className="participationTitle">Join now!</p>
            <p className="otpText">
              Thank you for your participation. See you at the Jaipur Pink Panthers Home Games - find Batery Zone and
              win prizes - Team Jerseys, power banks and other prizes every game!
            </p>
          </div>
        ) : showOTPScreen === false ? (
          <div className="participationContainer">
            <p className="participationTitle">Join now!</p>

            <TextInput
              inputTitle={"Your Name"}
              inputPlaceholder={"Insert Name"}
              value={name}
              setValue={setName}
              type={"text"}
              error={errorsObject?.name}
            />

            <TextInput
              inputTitle={"Your Email"}
              inputPlaceholder={"Insert Email"}
              value={email}
              setValue={setEmail}
              type={"text"}
              error={errorsObject?.email}
            />

            <PhoneInput
              dialCode={dialCode}
              setDialCode={setDialCode}
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
            />

            <DateOfBirthInput
              inputTitle="Date of Birth"
              hint="You must be at least 18 years old"
              dob={DOB}
              setDob={setDOB}
              error={errorsObject?.dob}
            />

            <div className="policyBlock">
              <input
                type="checkbox"
                className="checkbox"
                checked={checkboxDone}
                onChange={() => {
                  setCheckboxDone(!checkboxDone);
                }}
              />

              <p>
                I have read, understand and agree with the
                <span className="policyHighlightedText" onClick={() => window.open("https://batery.ai/policy")}>
                  Terms and Conditions, Privacy Policy
                </span>
                , and confirm that I am over 18 years of age.
              </p>
            </div>

            <p className="errorText">{errorText}</p>

            <div className="buttonsBlock">
              <button className="continueButton" onClick={() => validateData()}>
                Continue
              </button>
            </div>
          </div>
        ) : (
          <div className="participationContainer">
            <div className="otpInput">
              <p className="participationTitle">Join now!</p>
              <p className="otpText">We've sent you the OTP code, please insert it below to proceed</p>

              <OTPInput otp={otp} setOtp={setOtp} />

              <div className="buttonBlock">
                <p className="errorText">{OTPErrorText}</p>
                <button className="nextButton" onClick={() => checkOTP()}>
                  Next
                </button>

                {showSendAgain && (
                  <button className="sendAgainButton" onClick={() => sendAgain()}>
                    Send code again
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
